module.exports = __webpack_public_path__ + "static/media/hero-cv-2.3beff22.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/audio/hero-cv-2.ogg
// module id = 5WsH
// module chunks = 13